<template>
  <div></div>
</template>

<script>
import auth from "@/api/auth";
import helpers from "@/components/app/customcomp/helpers.js";
import moment from "moment"
export default {
  data() {
    return {
     
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      dovizList: [],
    };
  },
  methods: {
    getCurrencyList() {
      var params1 = {
        CompanyCode: this.credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params1, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.dovizList = response.body;
            this.$emit("getCurrencyList", this.dovizList);
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    },
    getCurrencyValue(val) {
      // Bos doviz kodunda kur sorulmaz; sunucu "Doviz Kodu Bos olamaz" diye 500 donuyordu.
      if (val == null || val == '') {
        return;
      }

      var params1 = {
        Tarih: helpers.getDateNow(),
        DovizKod: val,
      };
      
      this.$http
        .post(auth.API_URL + "api/Definitions/GetWebRate", params1, {
          headers: auth.getAuthCompaniesInfo()
        })
        .then(
          (response) => {
          if(response.body == 0.0){
            this.$emit("setCurrencyValue", 1);
          }else{
            this.$emit("setCurrencyValue", response.body);
          }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Kur Hesapla";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Kur Hesapla";
              this.snackbar = true;
            }
          }
        );
    },
    getCurrencyValuewithdate(val,valtarih) {
      // Bos doviz kodunda kur sorulmaz; sunucu "Doviz Kodu Bos olamaz" diye 500 donuyordu.
      if (val == null || val == '') {
        return;
      }

      var params1 = {
        Tarih: moment(valtarih).format('YYYY-MM-DD'),
        DovizKod: val,
      };
      
      this.$http
        .post(auth.API_URL + "api/Definitions/GetWebRate", params1, {
          headers: auth.getAuthCompaniesInfo()
        })
        .then(
          (response) => {
          if(response.body == 0.0){
            this.$emit("setCurrencyValue", 1);
          }else{
            this.$emit("setCurrencyValue", response.body);
          }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Kur Hesapla";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Kur Hesapla";
              this.snackbar = true;
            }
          }
        );
    },
  },
};
</script>

<style>
</style>